import { useState, useEffect } from 'react';
import { useImportETicketMutation } from '@services/product/eTicket/e-ticket.endpoints';
import { ETicketType } from '@services/product/eTicketType/e-ticket-type.types';
import { useGetETicketTypesMutation } from '@services/product/eTicketType/e-ticket-type.endpoints';
import Swal from 'sweetalert2';

export const useImportETicketsPageVM = () => {
    const [eticketTypes, setETicketTypes] = useState<ETicketType[]>([]);

    const [
        importETicket,
        {
            isSuccess: isImportETicketSuccess,
            isLoading: isImportETicketLoading
        }
    ] = useImportETicketMutation();


    const [
        getETicketTypes,
        {
            isSuccess: isGetETicketTypesSuccess,
            isLoading: isGetETicketTypesLoading,
            data: getETicketTypesData
        }
    ] = useGetETicketTypesMutation();
    
    useEffect(() => {
        if(isImportETicketSuccess) {
            Swal.fire({
                title: 'Succès',
                text: 'Les e-billets ont été importés avec succès',
                icon: 'success'
            });
        }
    }, [isImportETicketSuccess]);

    useEffect(() => {
        if(isGetETicketTypesSuccess) {
            setETicketTypes(getETicketTypesData?.data || []);
        }
    }, [isGetETicketTypesSuccess]);

    useEffect(() => {
        getETicketTypes(undefined);
    }, []);

    return {
        eticketTypes,
        importETicket,
        isImportETicketLoading,
        isGetETicketTypesLoading
    };
};
